import React from 'react';
import { AccountFragmentFragment } from '../../api';
import AccountProperties from './AccountProperties';
import AccountUsersOverview from './AccountUsersOverview';

interface Props {
  account: AccountFragmentFragment;
  onAddAccount: any;
}

const AccountDetail: React.FunctionComponent<Props> = (props) => {
  return (
    <div>
      <AccountProperties account={props.account} onAddAccount={props.onAddAccount} />
      <div className="sciui-grid sciui-m-b-l">
        <div className="sciui-grid-item-m-12 sciui-grid-item-l-12">
          <AccountUsersOverview account={props.account.id} />
        </div>
      </div>
    </div>
  );
};

export default AccountDetail;
